import React from "react";

export interface TextFieldProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: string;
  label?: string;
  primaryTextColor?: string;
  errorColor?: string;
  errorMessage?: string;
  inputType?: "text" | "numeric" | "email" | "tel";
}

export const TextField = (props: TextFieldProps) => {
  return (
    <div style={{ width: "100%", margin: "10px 0px" }}>
      <div
        style={{
          width: "fit-content",
          paddingLeft: "2px",
          paddingRight: "4px",
          marginBottom: "2px",
          color: props.primaryTextColor ?? "#fff",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {props.label}
      </div>
      <input
        type={"text"}
        inputMode={props.inputType ?? "text"}
        value={props.value}
        placeholder={props.placeholder}
        disabled={props.disabled}
        style={{
          width: "100%",
          backgroundColor: "transparent",
          borderRadius: "6px",
          padding: "8px",
          textAlign: "center",
          color: props.primaryTextColor,
          border: `1px solid ${props.primaryTextColor}`,
        }}
        onChange={props.onChange}
      />
      {props.errorMessage && (
        <p
          style={{
            color: props.errorColor ?? "#fa7373",
            fontSize: "12px",
            marginTop: "2px",
            textAlign: "left",
          }}
        >
          {props.errorMessage}
        </p>
      )}
    </div>
  );
};
